import angular from 'angular';

import Modals from '../../base/modals';

import EditEquipment from './editEquipments.component';
import EditTripWire from './editTripWire.component';
import Equipment from './equipment.component';
import EquipmentTable from './equipmentTable.component';
import RcuService from './rcu.service';

import { downgradedModule } from '../../../ng-app/main';

export default angular
  .module('petroCloud.admin.equipment', [
    Modals,
    downgradedModule
  ])
  .component(EditEquipment.name, EditEquipment)
  .component(EditTripWire.name, EditTripWire)
  .component(Equipment.name, Equipment)
  .component(EquipmentTable.name, EquipmentTable)
  .service('RcuService', RcuService)
  .name;
